
import MyModal from '@/components/modals/MyModal.vue';
import { mapGetters, mapMutations } from 'vuex';

export default {
    name: 'ModalFacebookErrorAuth',
    components: { MyModal },
    methods: {
        ...mapMutations({
            setIsOpen: 'auth/SET_FACEBOOK_ERROR_LOGIN_OPEN'
        })
    },
    computed: {
        ...mapGetters({
            isOpen: 'auth/getIsFacebookErrorLoginOpen'
        })
    }
};
